import { Phone } from "lucide-react";

const SiteFooter = () => {
  return (
    <footer className="bg-neutral-900 text-neutral-100 py-12 border-t border-neutral-800">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          <div>
            <h3 className="font-display text-xl font-extrabold mb-2">Computer Zone</h3>
            <p className="text-neutral-400 text-sm">
              Tech Support Heroes — Doing right for over 24 years.
            </p>
          </div>

          <div className="text-center">
            <a
              href="tel:+16782360376"
              className="inline-flex items-center gap-2 text-neutral-100 font-display font-bold text-lg hover:opacity-80 transition-opacity"
            >
              <Phone className="h-5 w-5" />
              (678) 236-0376
            </a>
          </div>

          <div className="text-right">
            <p className="text-neutral-400 text-sm">
              © {new Date().getFullYear()} Computer Zone Atlanta. All rights reserved.
            </p>
            <div className="flex justify-end gap-4 mt-2 text-sm">
              <a href="/privacy-policy" className="text-neutral-400 hover:text-neutral-100 transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-neutral-400 hover:text-neutral-100 transition-colors">
                Terms of Service
              </a>
              <a href="/blog" className="text-neutral-400 hover:text-neutral-100 transition-colors">
                Blog
              </a>
              <a href="/admin/blog" className="text-neutral-400 hover:text-neutral-100 transition-colors">
                Staff Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
